<!-- 需求提报 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="listTypeInfo.width"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template #applyCode="{scope}">
          <span
            class="table-handle-btn"
            @click="goPath(scope.row, '/ES/applyConfirm/applyConfirmAudit')"
            >{{ scope.row.applyCode }}</span
          >
        </template>
        <template #supplierType="{scope}">
          <span>{{ getSupplierType(scope.row.supplierType) }}</span>
        </template>

        <template #amount="{scope}">
          <span>{{ scope.row.amount | thousandsSeparator }}</span>
        </template>

        <template #applyStatus="{scope}">
          <span>{{ getApplyStatusType(scope.row.applyStatus) }}</span>
        </template>

        <template #handle="{ scope }">
          <span
            class="table-handle-btn"
            @click="goPath(scope.row, '/ES/applyConfirm/applyConfirmAudit')"
            v-if="
              scope.row.applyStatus === '102' || scope.row.applyStatus === '103'
            "
          >
            查看
          </span>
          <span
            v-if="scope.row.applyStatus === '101'"
            @click="goPath(scope.row, '/ES/applyConfirm/applyConfirmAudit')"
            class="table-handle-btn"
          >
            审核
          </span>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@/modules/projectA/api/ESorganization';
import mixins from './components/mixins';
import {
  tableLabel,
  fieldList,
  listTypeInfo
} from './components/componentsData.js';
export default {
  mixins: [mixins],
  data() {
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        applyCode: '',
        applyStatus: '101',
        companyName: '',
        supplierType: ''
      },
      total: 0,
      cloneListQuery: {},
      tableData: [
        /* {
          applyId: 461537,
          applyType: '1',
          isUploadAgreement: 0,
          applyCode: 'SQ230804023',
          applyTime: '2023-08-04 17:48:31',
          applicant: '测试申请人',
          amount: 449849.4,
          creditRound: '1',
          applyStatus: '103',
          sendTime: '2023-08-04 17:48:53',
          companyId: 143049,
          companyName: '上海晨光科力普办公用品有限公司sssss（测试）-1',
          siteReviewFee: 27000,
          mobile: '18612113131',
          email: '123@123.com',
          address: '上海市徐汇区古美路1528号A-2幢晨光科技大厦11层8888',
          factory: '测试生产地址',
          supplierType: '101',
          delStatus: 0
        },
        {
          applyId: 461524,
          applyType: '1',
          isUploadAgreement: 1,
          applyCode: 'SQ230804017',
          applyTime: '2023-08-04 14:02:46',
          applicant: '111',
          amount: 280,
          creditRound: '1',
          applyStatus: '103',
          sendTime: '2023-08-04 14:03:46',
          companyId: 110922,
          companyName: '河北英凯模金属网有限公司',
          siteReviewFee: 27000,
          mobile: '1111',
          email: '111',
          address: '河北省安平县陵园东街68号',
          factory: '111',
          supplierType: '101',
          delStatus: 0
        } */
      ]
    };
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },

  methods: {
    /* applyStatusList: [
    { name: '全部', id: 104 },
    { name: '待确认', id: 101 },
    { name: '申请驳回', id: 102 },
    { name: '确认通过', id: 103 },
  ], */
    getSupplierType(supplierType) {
      const { supplierTypeList } = this.listTypeInfo;
      const { name } =
        supplierTypeList.find(item => {
          return item.id === Number(supplierType);
        }) || {};
      return name;
    },

    getApplyStatusType(applyStatusType) {
      const { applyStatusList } = this.listTypeInfo;
      const { name } =
        applyStatusList.find(item => {
          return item.id === applyStatusType;
        }) || {};
      return name;
    },

    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.loadApplyInfos(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = res.data;
          this.tableData = [...data?.records];
          this.total = data?.total;
        }
      });
    },

    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },

    async goPath(row, path) {
      const { applyId, applyStatus } = row;
      this.$router.push({
        path,
        query: {
          applyId,
          applyStatus
        }
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.productName-item {
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  padding: 8px 0;
  margin: 0 -10px;
  &:last-child {
    border-bottom: none;
    margin-bottom: -8px;
  }
  &:first-child {
    margin-top: -8px;
  }
}
</style>
